<template>
    <div class="attendance-info">
        <div class="flex ai-c col-4">
            <el-input v-model="query.condition.studentname" size="medium" clearable placeholder="学员名称"></el-input>
            <div class="flex ai-c ml-10">
                <el-button @click="() => getStudyDetailsByPeriod(query)" type="primary" icon="el-icon-search" plain>搜索</el-button>
                <el-button @click="reset" icon="el-icon-refresh">重置</el-button>
            </div>
        </div>
        <el-table :data="attendanceList" v-loading="loading" border class="mt-20 table-fixed-col">
            <el-table-column label="序号" type="index" :index="indexFormatter" key="index" align="center" :width="getTableHeaderWidthByOrderCol()" fixed></el-table-column>
            <el-table-column label="课时名称" prop="periodname" key="periodname" fixed min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column label="上课时间" prop="periodtime" key="periodtime" align="center" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="学员昵称" prop="nickname" key="nickname" align="center" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="学员名称" prop="studentname" key="studentname" align="center" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="考勤方式" prop="checktypename" key="checktypename" align="center" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="考勤状态" prop="checkstatusname" key="checkstatusname" align="center" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="考勤时间" prop="checktime" key="checktime" align="center" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" key="control" align="center" min-width="80" fixed="right" show-overflow-tooltip>
                <span @click="!row.checks ? saveCheckInfo(row.code) : false" :class="['pointer', !row.checks?'color-primary':'color-info']" slot-scope="{ row }">打卡</span>
            </el-table-column>
        </el-table>
        <el-pagination :hide-on-single-page="!total || total < 1" class="mt-20 flex ai-c jc-fd" @size-change="handePageSizeChange" @current-change="curPageChange" @prev-click="curPageChange" @next-click="curPageChange" layout="total, sizes, prev, pager, next" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="20" :current-page.sync="queryCache.page" background></el-pagination>
    </div>
</template>
<script>
import {
  getStudyDetailsByPeriod,
  saveCheckInfo
} from '@/api/measApi/studyManagement'
import { deepClone } from '@/common/js/tools'
export default {
  data: () => ({
    total: 0,
    loading: false,
    attendanceList: [], // 考勤列表
    query: {
      condition: {
        studentname: '',
        classcode: '',
        classcoursecode: '',
        code: ''
      }
    },
    queryCache: {
      page: 1,
      pagesize: 20
    }
  }),
  props: {
    // 班级code
    classCode: {
      require: true,
      type: String
    },
    // 课程code
    courseCode: {
      require: true,
      type: String
    },
    // 目标code
    code: {
      type: String,
      default: ''
    }
  },
  mounted() {
    Object.assign(this.queryCache, deepClone(this.query))
  },
  methods: {
    init() {
      this.getStudyDetailsByPeriod()
    },
    reset() {
      this.query.condition.studentname = ''
      this.getStudyDetailsByPeriod(this.query)
    },
    // 打卡
    async saveCheckInfo(code) {
      const res = await saveCheckInfo({ code, checkstatus: 10 })
      if (res.code === '000') {
        this.$message.success(res.msg)
        this.getStudyDetailsByPeriod()
      }
    },
    // 获取考勤列表
    async getStudyDetailsByPeriod(param) {
      if (param) {
        this.queryCache.page = 1
      }
      Object.assign(this.queryCache, deepClone(param))
      this.queryCache.condition.classcoursecode = this.courseCode
      this.queryCache.condition.classcode = this.classCode
      this.queryCache.condition.code = this.code
      this.loading = true
      try {
        const res = await getStudyDetailsByPeriod(this.queryCache)
        if (res.code === '000') {
          this.attendanceList = res.data
          this.total = res.pageinfo.rowcount
        }
        this.loading = false
      } catch {
        this.loading = false
      }
    },
    // 序号格式化
    indexFormatter(index) {
      return index + 1 + (this.queryCache.page - 1) * this.queryCache.pagesize
    },
    // 分页大小改变
    handePageSizeChange(e) {
      this.queryCache.page = 1
      this.queryCache.pagesize = e
      this.getStudyDetailsByPeriod()
    },
    // 页面跳转
    curPageChange(e) {
      this.queryCache.page = e
      this.getStudyDetailsByPeriod()
    }
  }
}
</script>
<style lang="scss" scoped>
.attendance-info {
  padding: 2px;
  .el-button {
    margin-bottom: 0 !important;
  }
  ::v-deep .el-input,
  .el-select {
    height: 36px !important;

    > .el-input {
      height: 36px !important;
    }
  }
}
</style>
